import {Integer} from 'platform/foundation';

import {UserSidebarIconSize} from '@dms/api/shared';

export const SIDEBAR_DESKTOP_ICON_SIZE: Record<UserSidebarIconSize, Integer> = {
  default: 5,
  large: 6,
};
